var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seat-map-price-view-container"},[(_vm.isLoading)?[_vm._m(0)]:[_c('span',[_vm._v(_vm._s(_vm.$t("ancillarySeatMap_lblGrandTotal")))]),_c('span',{staticClass:"amount"},[_vm._v(_vm._s(_vm._f("price")(_vm.totalAmount,_vm.currency)))])]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-loader-wrapper"},[_c('span',{staticClass:"g-radial-loader"})])
}]

export { render, staticRenderFns }